import { useEffect } from 'react';
import { useGlobalStore } from '../global-store/global-store';
import { useWorkPeriodStore } from './work-period-store';

/**
 * Hook to automatically reset work period store selections when organization or portfolio changes
 * This hook should be used in components that need to ensure work period selections are reset
 * when the global context (organization/portfolio) changes
 */
const useWorkPeriodContextReset = () => {
  const organization = useGlobalStore((state) => state.organization);
  const portfolio = useGlobalStore((state) => state.portfolio);
  const checkAndResetOnContextChange = useWorkPeriodStore((state) => state.checkAndResetOnContextChange);

  useEffect(() => {
    checkAndResetOnContextChange(organization, portfolio);
  }, [organization, portfolio, checkAndResetOnContextChange]);
};

export { useWorkPeriodContextReset };
